// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

const NavigationItem = ({includeFavorites, label, path}) =>
    <li className='navigation-item'>
        {includeFavorites &&
            <FavoriteIcon
                id={label}
                route={path}
            />
        }
        <Link
            to={`${path}`}
        >
            <FormattedMessage id={label}/>
        </Link>
    </li>;

NavigationItem.displayName = 'NavigationItem';
NavigationItem.propTypes = {
    includeFavorites: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
};
NavigationItem.defaultProps = {
    includeFavorites: true
};

export default NavigationItem;




// WEBPACK FOOTER //
// ./src/shared/components/navigation-list/navigation-item.js